import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { GenerateControlePatrimonioColumnDefinition } from "./columns";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GetAllControledePatrimonioDaoModel } from "../../../domain/models/ControledePatrimonioModel";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { Header } from "./components/header";
import { useMaquinasEquipListaViewModel } from "../../viewModels/maquinas_equip_lista_view_model";
import { GridPinnedColumnFields } from "@mui/x-data-grid-pro";

import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import AlertError from "../../../../../common/components/alert_error";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

/**
 * MaquinasEquip_lista
 */

export const MaquinasEquip_lista = () => {
  const viewModel = useMaquinasEquipListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControlePatrimonioColumnDefinition({
      onActionEditar: viewModel.handleEditarControlePatrimonio,
      onActionDeletar: viewModel.handleDeleteOpenModal,
      onActionViewItem: viewModel.handleViewItens,
    });
  }, [
    viewModel.handleEditarControlePatrimonio,
    viewModel.handleDeleteOpenModal,
    viewModel.handleViewItens,
  ]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields | undefined => {
    return viewModel.controlePatrimonioLista.length > 0 ? (
      { right: ['idMaquinaEquip', 'itens'] }
    ) : (
      {}
    );
  }, [
    viewModel.controlePatrimonioLista,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[125px]">
                <PrimaryButton
                  buttonColor="yellow"
                  onMouseDown={e => {
                    viewModel.handleReportMaquinasEquip();
                    e.preventDefault();
                  }}>
                  Relatório
                </PrimaryButton>
              </div>
              <div className="w-[125px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={viewModel.handleCreate}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Controle de Patrimônio
          </Link>
          <Typography className="text-primary-green">Controle de Patrimônio</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Controle de Patrimônio</h1>
          <RefreshButton onClick={() => window.location.reload()} />
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <Header
                  centrocusto={viewModel.filters.centroCusto}
                  nome={viewModel.filters.descricao}
                  status={viewModel.filters.status}
                  codigo={viewModel.filters.codigo}
                  localizacao={viewModel.filters.localizacao}
                  centrocustoDropDown={viewModel.centroCustoDropdown}
                  onNome={viewModel.handleDescricaoChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onCodigoChange={viewModel.handleCodigoChange}
                  onLocalizacaoChange={viewModel.handleLocalizacaoChange}
                  onCentroCustoChange={viewModel.handleCentroCustoChange}
                  onClear={viewModel.handleClear}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                      />
                    </div>
                  </div>

                  <StyledDataGrid
                    tableName="MateriaisControlados"
                    disableColumnMenu={false}
                    showToolbar={true}
                    disableRowSelectionOnClick={true}
                    getRowId={(row: GetAllControledePatrimonioDaoModel) => row.idMaquinaEquip ?? ""}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    checkboxSelection={false}
                    pinnedColumns={pinnedColumns}
                    rows={viewModel.controlePatrimonioLista}
                    rowCount={viewModel.controlePatrimonioLista.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <div className="flex flex-col justify-between flex-1">
                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                    />
                  </div>
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        title={`Você realmente deseja excluir este item?`}
        onClose={() => viewModel.handleDeleteOpenModal(null, false)}
        onDelete={viewModel.handleDeletarControlePatrimonio}
      />
    </>
  );
};
